'use client';

import {useRouter, useSearchParams} from 'next/navigation';
import {useTranslations} from 'next-intl';
import type {FC} from 'react';

interface NoResultsProps {
  className?: string;
  hideNoResultsDescription?: boolean;
}

export const NoResults: FC<NoResultsProps> = ({className, hideNoResultsDescription = false}) => {
  const t = useTranslations('actions.emptyState');

  const router = useRouter();
  // const path = usePathname();
  const searchParams = useSearchParams();

  const clearFilters = () => {
    const params = new URLSearchParams();
    const page = searchParams.get('page');
    if (page) params.set('page', page);
    router.push(`?${params.toString()}`);
  };

  return (
    <div
      className={`flex w-full flex-col items-center justify-center gap-4 rounded-2xl border border-[#A0A3E266] ${className}`}
    >
      <div className="flex flex-col items-center justify-start gap-1 md:gap-2">
        <h3 className="font-inter text-center text-[20px] font-semibold leading-[1.4] text-[#E9ECF0] md:text-[28px]">
          {t('title')}
        </h3>
        {!hideNoResultsDescription && (
          <div className="flex flex-col items-center gap-2">
            <p
              className="font-inter cursor-pointer text-center text-[16px] font-medium leading-[1.4] text-[#A0A3E2] md:text-[20px]"
              onClick={clearFilters}
            >
              {t('description')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
